export const isPlainRecord = (
  value: unknown,
): value is Record<string, unknown> => {
  if (value === null || value === undefined) {
    return false;
  }
  if (typeof value !== 'object') {
    return false;
  }

  return !Array.isArray(value);
};
